export default "__VITE_ASSET__9oNIFp6L__"